module.exports = __webpack_public_path__ + "img/B01_HQ04.e232f7af.jpg";